import {Controller} from "stimulus"
import {TimelineLite} from "gsap/TimelineLite"
import {TweenLite} from "gsap/TweenLite"

/**
 * Form bone de recharge
 */
export default class extends Controller {

    static targets = [
        "targets",
        "buttons",
    ]

    initialize() {
    }

    filter(e) {
        e.preventDefault()
        const $el = e.currentTarget
        const id = $el.dataset.id
        const group = $el.dataset.group
        const $target = this.$targets.filter($item => $item.dataset.id === id && $item.dataset.group === group)
        const $targets = this.$targets.filter($item => $item.dataset.group === group)
        const $buttons = this.$buttons.filter($item => $item.dataset.group === group)
        const $hasActiveClass = $el.classList.contains("is-active")
        const $activeButtons = this.$buttons.filter($item => $item.dataset.id === id && $item.dataset.group === group)
        TweenLite.set($buttons, {className: "-=is-active"})
        TweenLite.set($activeButtons, {className: "+=is-active"})
        if($hasActiveClass){
            const tl = new TimelineLite()
            tl.to($targets, 0.2, {opacity: 0, onComplete: () => TweenLite.set($targets, {className: "+=u-hidden"})})
            tl.set($target, {opacity: 0, className: "+=u-hidden"})
            TweenLite.set($el, {className: "-=is-active"})
            tl.add("now")
        }else{
            if ($target) {
                const tl = new TimelineLite()
                tl.to($targets, 0.2, {opacity: 0, onComplete: () => TweenLite.set($targets, {className: "+=u-hidden"})})
                tl.set($target, {opacity: 0, className: "-=u-hidden"})
                tl.add("now")
                tl.to($target, 0.2, {opacity: 1}, "now")
            }
        }



    }

    get $targets() {
        return this.targetsTargets
    }

    get $buttons() {
        return this.buttonsTargets
    }

}
